import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { WorkerRegistroContabileModalComponent } from './worker-registro-contabile-modal';

export const WorkerRegistroContabileModalModule: string = ng
    .module('worker-registro-contabile-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerRegistroContabileModalComponent', WorkerRegistroContabileModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-registro-contabile-modal/worker-registro-contabile-modal.module.ts